const findPersonInTreeWithPreviousPerson = ({ personAtn, treeData }) => {
  const personIndexInTree = treeData.findIndex((person) => person.atn === personAtn)
  const personExists = personIndexInTree > 1
  const previousPerson = personExists ? treeData[personIndexInTree - 1] : null

  return {
    personIndexInTree,
    personExists,
    previousPerson,
  }
}

export default function findNewLineType(leftSide, rightSide, treeData, viewType) {
  let lineType
  const lineStyle = viewType === 'familylines' ? '' : 'Dark'
  const leftSideAtn = leftSide && leftSide.atn ? leftSide.atn : -1
  const rightSideAtn = rightSide && rightSide.atn ? rightSide.atn : -1

  if (viewType === 'familylines') {
    if (!treeData || treeData.length <= 1) {
      lineType = 'startLines'
    } else if (!treeData.some((person) => person.atn === leftSideAtn || person.atn === rightSideAtn)) {
      if (treeData[treeData.length - 1].atn % 2 === 0) {
        lineType = 'endLeft'
      } else {
        lineType = 'endRight'
      }
    }
  }
  if (treeData) {
    const treeContainsLeftSideAtn = treeData.some((person) => person.atn === leftSideAtn)
    const treeContainsRightSideAtn = treeData.some((person) => person.atn === rightSideAtn)

    if (treeContainsLeftSideAtn) {
      if (leftSideAtn <= 3) {
        lineType = 'startLeft'
      } else {
        const details = findPersonInTreeWithPreviousPerson({ personAtn: leftSideAtn, treeData })

        if (details.personExists && details.previousPerson) {
          const isEvenNumberAtn = details.previousPerson.atn % 2 === 0
          lineType = isEvenNumberAtn ? 'straightLeft' : 'bottomTopLeft'
        }
      }
    } else if (treeContainsRightSideAtn) {
      if (leftSideAtn <= 3) {
        lineType = 'startRight'
      } else {
        const details = findPersonInTreeWithPreviousPerson({ personAtn: rightSideAtn, treeData })

        if (details.personExists && details.previousPerson) {
          const isEventNumberAtn = treeData[details.personIndexInTree - 1].atn % 2 === 0
          lineType = isEventNumberAtn ? 'bottomTopRight' : 'straightRight'
        }
      }
    }
  }

  return lineType + lineStyle
}

export const isActiveAtn = ({ leftAtn, rightAtn, treeData }) => {
  const actives = {
    left: false,
    right: false,
  }

  if (treeData) {
    if (treeData.some((person) => person?.atn === leftAtn)) {
      actives.left = true
    } else if (treeData.some((person) => person?.atn === rightAtn)) {
      actives.right = true
    } else {
      actives.right = true
      actives.left = true
    }
  }

  return actives
}
